module.exports = __webpack_public_path__ + "static/media/item-14.f953a164.png";